// NOTE: keep this 'enum' in sync with GunActionType in gun_component.h
export const ACTION_TYPE_PROJECTILE = 0;
export const ACTION_TYPE_STATIC_PROJECTILE = 1;
export const ACTION_TYPE_MODIFIER = 2;
export const ACTION_TYPE_DRAW_MANY = 3;
export const ACTION_TYPE_MATERIAL = 4;
export const ACTION_TYPE_OTHER = 5;
export const ACTION_TYPE_UTILITY = 6;
export const ACTION_TYPE_PASSIVE = 7;
